import React, { useEffect, useState } from 'react';

import ModalComponent from "../../components/Modal";
import Viewer from 'react-viewer';
import 'tui-image-editor/dist/tui-image-editor.css'
import ImageEditor from '@toast-ui/react-image-editor'
import moment from 'moment';
import './imageview.scss';
import IconPdf from '../../assets/svg/pdf.svg';
import IconSearch from '../../assets/svg/ic-actions-search.svg';
import IconEdit from '../../assets/svg/ic-contact-edit.svg';

const ImageView = ({ midias, width = 114, height = 114, edit = true }) => {

  const [editImage, setEditImage] = useState(false);
  const [showImg, setShowImg] = useState(false);
  const [showImgIndex, setShowImgIndex] = useState(0);
  const [editImageSrc, setEditImageSrc] = useState(null);

  return (
    <>
      <ModalComponent
        openModal={editImage}
        closeModal={() => setEditImage(false)}
      >
        <div style={{ height: '98%' }}>

          <ImageEditor
            includeUI={{
              loadImage: {
                path: editImageSrc,
                name: 'a',
                url: editImageSrc
              },
              menu: ['crop', 'flip', 'rotate', 'draw', 'shape', 'icon', 'text', 'mask', 'filter'],
              initMenu: '',
              uiSize: {
                width: '100%',
                height: '100%'
              },
              menuBarPosition: 'bottom',
              loadImageFromURL: {
                path: editImageSrc,
                name: 'a'
              },
            }}

            cssMaxHeight={500}
            cssMaxWidth={700}
            selectionStyle={{
              cornerSize: 20,
              rotatingPointOffset: 70
            }}
            usageStatistics={true}
          />
        </div>
      </ModalComponent>

      <Viewer
        visible={showImg}
        onClose={() => setShowImg(!showImg)}
        images={midias}
        activeIndex={showImgIndex}
        onChange={(activeImage, index) => { }}
      />

      <div className="gb-cont-midia">
        {midias
          ? midias.map((item, index) => {
            return (
              <div className="gb-midia" key={index} style={{ height: height, width: width }}>
                <div className="gb-midia-img" style={{ height: height, width: width }}>
                  {item.src.indexOf('.pdf') > 0 ? (
                    <a href={item.src} target="_blank">
                      {/* <i className="far fa-file-pdf"></i> */}
                      <img src={IconPdf} style={{ height: height, width: width }} />
                    </a>
                  ) : (
                    <img
                      src={item.src}
                      alt="new"
                      onClick={() => {
                        setShowImgIndex(index);
                        setShowImg(true);
                      }}
                      style={{ height: height, width: width }}
                    />
                  )}
                </div>

                {item.data && item.data != '' ? <div className="gb-midia-hora">{moment(item.data, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY HH:mm")}</div> : null}
                {item.name && item.name != '' ? <div className="gb-midia-hora">{item.name}</div> : null}

                {item.src.indexOf('.pdf') < 0 && edit ?
                  <button onClick={() => {
                    if (item.src.indexOf('.pdf') > 0) {
                      window.open(item.src);
                    } else {
                      setEditImage(true);
                      setEditImageSrc(item.src);
                    }
                  }} className="gb-image-btn-view left">
                    <img src={IconEdit} />
                  </button> : null}

                <button onClick={() => {
                  if (item.src.indexOf('.pdf') > 0) {
                    window.open(item.src);
                  } else {
                    setShowImgIndex(index);
                    setShowImg(true);
                  }
                }} className="gb-image-btn-view right">
                  <img src={IconSearch} />
                </button>
              </div>
            );
          })
          : null}
      </div>
    </>
  )
}

export default ImageView;